module.exports = __webpack_public_path__ + "img/jens_hopp.38231fe6.png";